import {
  AppBar,
  Toolbar,
  Button,
  Container,
  Menu,
  MenuItem,
  Fade,
  Grid,
  Hidden,
  Popper,
  Grow,
  Paper,
  MenuList,
  ClickAwayListener,
  ListItem,
  ListItemIcon,
  List,
  ListItemText,
  Drawer,
  Divider,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
  Box,
  Slide,
  useScrollTrigger,
  makeStyles
} from "@material-ui/core";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserContext } from "../../contexts/UserContext";
import { useContext, useState, useRef } from "react";
import { Snackbar } from "@material-ui/core";

import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

import { useNavigate } from "react-router-dom";

import MuiAlert from "@material-ui/lab/Alert";

import Axios from "axios";
import { Link } from "react-router-dom";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(20px)",
    borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
  },
  toolbar: {
    padding: "6px 0",
    minHeight: 64,
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },
  logoWrapper: {
    width: 42,
    height: 42,
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(76, 0, 76, 0.15)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 4px 16px rgba(76, 0, 76, 0.25)",
    },
  },
  logo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  brandName: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#4c004c",
    marginLeft: 12,
    letterSpacing: "-0.3px",
  },
  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  navButton: {
    color: "#333333",
    fontSize: "0.85rem",
    fontWeight: 500,
    padding: "8px 16px",
    borderRadius: 8,
    textTransform: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(76, 0, 76, 0.06)",
      color: "#4c004c",
    },
  },
  navButtonActive: {
    color: "#4c004c",
    backgroundColor: "rgba(76, 0, 76, 0.08)",
  },
  contactButton: {
    backgroundColor: "#4c004c",
    color: "#ffffff",
    fontSize: "0.85rem",
    fontWeight: 500,
    padding: "8px 20px",
    borderRadius: 20,
    textTransform: "none",
    marginLeft: 8,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#6b1b6b",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(76, 0, 76, 0.3)",
    },
  },
  menuButton: {
    color: "#4c004c",
    padding: 10,
    borderRadius: 10,
    backgroundColor: "rgba(76, 0, 76, 0.06)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(76, 0, 76, 0.12)",
    },
  },
  drawer: {
    "& .MuiDrawer-paper": {
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: "8px 0 24px",
      maxHeight: "80vh",
    },
  },
  drawerHandle: {
    width: 40,
    height: 4,
    backgroundColor: "#e0e0e0",
    borderRadius: 2,
    margin: "8px auto 16px",
  },
  drawerHeader: {
    padding: "16px 24px",
    borderBottom: "1px solid #f0f0f0",
    marginBottom: 8,
  },
  drawerTitle: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#4c004c",
  },
  drawerList: {
    padding: "0 16px",
  },
  drawerItem: {
    borderRadius: 12,
    marginBottom: 4,
    padding: "14px 16px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(76, 0, 76, 0.06)",
    },
  },
  drawerItemText: {
    "& .MuiListItemText-primary": {
      fontSize: "0.95rem",
      fontWeight: 500,
      color: "#333333",
    },
  },
  drawerContactButton: {
    margin: "16px 16px 8px",
    backgroundColor: "#4c004c",
    color: "#ffffff",
    borderRadius: 12,
    padding: "14px 20px",
    textTransform: "none",
    fontSize: "0.9rem",
    fontWeight: 500,
    width: "calc(100% - 32px)",
    boxSizing: "border-box",
    "&:hover": {
      backgroundColor: "#6b1b6b",
    },
  },
  accountButton: {
    color: "#4c004c",
    fontSize: "0.85rem",
    fontWeight: 500,
    padding: "8px 16px",
    borderRadius: 8,
    textTransform: "none",
    border: "1px solid rgba(76, 0, 76, 0.2)",
    marginLeft: 8,
    "&:hover": {
      backgroundColor: "rgba(76, 0, 76, 0.06)",
      borderColor: "#4c004c",
    },
  },
  accountMenu: {
    "& .MuiPaper-root": {
      borderRadius: 12,
      boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
      marginTop: 8,
      minWidth: 180,
    },
  },
  accountMenuItem: {
    padding: "12px 20px",
    fontSize: "0.9rem",
    "&:hover": {
      backgroundColor: "rgba(76, 0, 76, 0.06)",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export const NavBar = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  let navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const anchorRef1 = useRef(null);
  const [open1, setOpen1] = useState(false);

  const [snackBar, setSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("success");
  const [snackBarType, setSnackBarType] = useState("Invalid");

  //const open = Boolean(anchorEl);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleToggle1 = () => {
    setOpen1((prevOpen) => !prevOpen);
  };

  const handleClose1 = (event) => {
    if (anchorRef1.current && anchorRef1.current.contains(event.target)) {
      return;
    }
    setState({ ...state, ["bottom"]: false });
    setOpen1(false);
  };

  function handleListKeyDown1(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen1(false);
    }
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const openSnkbar = (type, msg) => {
    setSnackBarMsg(msg);
    setSnackBarType(type);
    setSnackBar(true);
  };

  const logout = () => {
    Axios.get("/api/logout", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        openSnkbar("success", res.data.msg);
        setUser(null);
        setOpen((prevOpen) => !prevOpen);
        setState({ ...state, ["bottom"]: false });
        navigate("/");
      } else {
      }
    });
  };

  return (
    <HideOnScroll {...props}>
      <AppBar 
        position="sticky" 
        id="back-to-top-anchor"
        elevation={0}
        className={classes.appBar}
      >
        <Container maxWidth="xl">
          <Snackbar
            open={snackBar}
            autoHideDuration={4000}
            onClose={() => setSnackBar(false)}
          >
            <Alert
              onClose={() => setSnackBar(false)}
              severity={snackBarType}
              style={{ color: snackBarType === "warning" ? "black" : "white" }}
            >
              {snackBarMsg}
            </Alert>
          </Snackbar>
          <Toolbar className={classes.toolbar}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              {/* Logo */}
              <Grid item>
                <Link to="/" className={classes.logoContainer}>
                  <Box className={classes.logoWrapper}>
                    <img
                      src="/static/logo.png"
                      alt="Arawinz logo"
                      className={classes.logo}
                    />
                  </Box>
                  <Hidden mdDown>
                    <Typography className={classes.brandName}>
                      Arawinz Soft Solutions
                    </Typography>
                  </Hidden>
                </Link>
              </Grid>

              {/* Mobile Menu Button */}
              <Grid item>
                <Hidden lgUp>
                  <IconButton 
                    onClick={toggleDrawer("bottom", true)}
                    className={classes.menuButton}
                  >
                    <MenuIcon />
                  </IconButton>

                  {/* Mobile Drawer */}
                  <Drawer
                    anchor="bottom"
                    open={state["bottom"]}
                    onClose={toggleDrawer("bottom", false)}
                    className={classes.drawer}
                  >
                    {/* Drawer Handle */}
                    <Box className={classes.drawerHandle} />

                    {/* Drawer Links */}
                    <List className={classes.drawerList}>
                      <ListItem
                        button
                        component={Link}
                        to="/about-us"
                        onClick={toggleDrawer("bottom", false)}
                        className={classes.drawerItem}
                      >
                        <ListItemText primary="About Us" className={classes.drawerItemText} />
                      </ListItem>
                      <ListItem
                        button
                        component={Link}
                        to="/our-services"
                        onClick={toggleDrawer("bottom", false)}
                        className={classes.drawerItem}
                      >
                        <ListItemText primary="Our Services" className={classes.drawerItemText} />
                      </ListItem>
                      <ListItem
                        button
                        component={Link}
                        to="/our-products"
                        onClick={toggleDrawer("bottom", false)}
                        className={classes.drawerItem}
                      >
                        <ListItemText primary="Our Products" className={classes.drawerItemText} />
                      </ListItem>
                      <ListItem
                        button
                        component={Link}
                        to="/our-team"
                        onClick={toggleDrawer("bottom", false)}
                        className={classes.drawerItem}
                      >
                        <ListItemText primary="Our Team" className={classes.drawerItemText} />
                      </ListItem>
                      <ListItem
                        button
                        component={Link}
                        to="/whats-new"
                        onClick={toggleDrawer("bottom", false)}
                        className={classes.drawerItem}
                      >
                        <ListItemText primary="What's New" className={classes.drawerItemText} />
                      </ListItem>
                      <ListItem
                        button
                        component={Link}
                        to="/careers"
                        onClick={toggleDrawer("bottom", false)}
                        className={classes.drawerItem}
                      >
                        <ListItemText primary="Join Us" className={classes.drawerItemText} />
                      </ListItem>
                    </List>

                    {/* Contact Button in Drawer */}
                    <Button
                      fullWidth
                      variant="contained"
                      component={Link}
                      to="/get-in-touch"
                      onClick={toggleDrawer("bottom", false)}
                      className={classes.drawerContactButton}
                    >
                      Contact Us
                    </Button>
                    {/* User Account in Drawer */}
                    {user && (
                      <Box style={{ padding: "16px 24px", borderTop: "1px solid #f0f0f0", marginTop: 8 }}>
                        <Button
                          ref={anchorRef1}
                          fullWidth
                          onClick={handleToggle1}
                          className={classes.accountButton}
                          style={{ justifyContent: "space-between" }}
                        >
                          <span>My Account</span>
                          <KeyboardArrowDownIcon />
                        </Button>
                        <Popper
                          open={open1}
                          anchorEl={anchorRef1.current}
                          role={undefined}
                          transition
                          disablePortal
                        >
                          {({ TransitionProps, placement }) => (
                            <Grow
                              {...TransitionProps}
                              style={{
                                transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                              }}
                            >
                              <Paper style={{ borderRadius: 12, marginTop: 8 }}>
                                <ClickAwayListener onClickAway={handleClose1}>
                                  <MenuList autoFocusItem={open1} onKeyDown={handleListKeyDown1}>
                                    <MenuItem onClick={handleClose1} component={Link} to="/dash" className={classes.accountMenuItem}>
                                      <AccountCircleIcon style={{ marginRight: 12, fontSize: 20 }} />
                                      Dashboard
                                    </MenuItem>
                                    <MenuItem onClick={logout} className={classes.accountMenuItem}>
                                      <ExitToAppIcon style={{ marginRight: 12, fontSize: 20 }} />
                                      Logout
                                    </MenuItem>
                                  </MenuList>
                                </ClickAwayListener>
                              </Paper>
                            </Grow>
                          )}
                        </Popper>
                      </Box>
                    )}
                  </Drawer>
                </Hidden>

                {/* Desktop Navigation */}
                <Hidden mdDown>
                  <Box className={classes.navLinks}>
                    <Button component={Link} to="/about-us" className={classes.navButton}>
                      About Us
                    </Button>
                    <Button component={Link} to="/our-services" className={classes.navButton}>
                      Services
                    </Button>
                    <Button component={Link} to="/our-products" className={classes.navButton}>
                      Products
                    </Button>
                    <Button component={Link} to="/our-team" className={classes.navButton}>
                      Our Team
                    </Button>
                    <Button component={Link} to="/whats-new" className={classes.navButton}>
                      What's New
                    </Button>
                    <Button component={Link} to="/careers" className={classes.navButton}>
                      Join Us
                    </Button>
                    <Button component={Link} to="/get-in-touch" className={classes.contactButton}>
                      Contact Us
                    </Button>

                    {/* Desktop User Account */}
                    {user && (
                      <>
                        <Button
                          ref={anchorRef}
                          onClick={handleToggle}
                          className={classes.accountButton}
                          endIcon={<KeyboardArrowDownIcon />}
                        >
                          My Account
                        </Button>
                        <Popper
                          open={open}
                          anchorEl={anchorRef.current}
                          role={undefined}
                          transition
                          disablePortal
                          className={classes.accountMenu}
                        >
                          {({ TransitionProps, placement }) => (
                            <Grow
                              {...TransitionProps}
                              style={{
                                transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                              }}
                            >
                              <Paper style={{ borderRadius: 12 }}>
                                <ClickAwayListener onClickAway={handleClose}>
                                  <MenuList autoFocusItem={open} onKeyDown={handleListKeyDown}>
                                    <MenuItem onClick={handleClose} component={Link} to="/dash" className={classes.accountMenuItem}>
                                      <AccountCircleIcon style={{ marginRight: 12, fontSize: 20, color: "#4c004c" }} />
                                      Dashboard
                                    </MenuItem>
                                    <MenuItem onClick={logout} className={classes.accountMenuItem}>
                                      <ExitToAppIcon style={{ marginRight: 12, fontSize: 20, color: "#4c004c" }} />
                                      Logout
                                    </MenuItem>
                                  </MenuList>
                                </ClickAwayListener>
                              </Paper>
                            </Grow>
                          )}
                        </Popper>
                      </>
                    )}
                  </Box>
                </Hidden>
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
    </HideOnScroll>
  );
};
